import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import '../App.css'; // Ensure to import your CSS
import '@fortawesome/fontawesome-free/css/all.min.css';

const Footer = () => {
  return (
    <footer className="curved-footer mt-5">
      <Container>
        <Row>
          <Col md={4} className="text-center">
            <h5>About Us</h5>
            <p>Explore the world of board games and embark on an unforgettable Everest trekking adventure with us!</p>
          </Col>
          <Col md={4} className="text-center">
            <h5>Quick Links</h5>
            <ul className="list-unstyled">
              <li><a href="/" className="text-white">Home</a></li>
              <li><a href="/Team" className="text-white">Our Team</a></li>
              <li><a href="/GameInfo" className="text-white">How To Play</a></li>
              <li><a href="/Contact" className="text-white">Contact</a></li>
            </ul>
          </Col>
          <Col md={4} className="text-center">
            <h5>Follow Us</h5>
            <a href="https://www.facebook.com/share/1ErPyaFQFR/" className="text-white me-3" target="_blank" rel="noopener noreferrer">
              <i className="fab fa-facebook"></i>
            </a>
            {/* Uncomment if you want to add Twitter */}
            {/* <a href="/" className="text-white me-3" target="_blank" rel="noopener noreferrer">
              <i className="fab fa-twitter"></i>
            </a> */}
            <a href="https://www.instagram.com/thechallengeofeverest?utm_source=qr&igsh=c2pvbHl6cWVtZWlx" className="text-white" target="_blank" rel="noopener noreferrer">
              <i className="fab fa-instagram"></i>
            </a>
          </Col>
        </Row>

        {/* Copyright Section */}
        <Row>
          <Col className="text-center mt-4 footer-content">
            <p>&copy; 2025 The Challenge of Everest Climb On! - Board Games. All Rights Reserved.</p>
            <p>
              <a href="/Privacy" className="text-white">Privacy Policy</a> | 
              <a href="/Terms" className="text-white"> Terms & Conditions</a>
            </p>
            <p className="text-white">
            Designed by:
              <a href="https://viyaantechnosoft.com/" target="_blank" rel="noopener noreferrer">
                 Viyaan Technosoft
              </a>
            </p>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default Footer;
